export default __webpack_public_path__ + "static/c1-20274efb001b993897c238de3266439a.jpg";